<vsf-modal [scrollable]="true" [visible]="visible" (close)="onCancel()">
    <div class="upload-modal">
        <div class="upload-modal__header">
            <h2 class="text-lg sm:text-xl font-semibold text-gray-900">
                Upload cart
            </h2>
            <button (click)="onCancel()" class="close-btn" aria-label="Close modal" type="button">
                <fa-icon [icon]="['fas', 'times']" class="w-5 h-5 sm:w-4 sm:h-4"></fa-icon>
            </button>
        </div>

        <div class="upload-modal__body">
        <div class="mb-4 sm:mb-6">
            <p class="text-gray-700 mb-3 text-sm sm:text-base leading-relaxed" *ngIf="!isConsolidatedFeedImport">
                Upload a list of product GTINs and quantities to build your cart.
                Put CONSOLIDATED or CONSOLIDATED-FEED in a row's Offer ID to select only from consolidated feed channels.
            </p>
            <p class="text-gray-700 mb-3 text-sm sm:text-base leading-relaxed" *ngIf="isConsolidatedFeedImport">
                Upload EAN and Quantity columns. Offers are selected only from active channels in the consolidated feed.
                Offer ID is optional: leave it blank or use CONSOLIDATED-FEED for automatic selection, or enter a feed pricelist ID to select a specific offer.
            </p>
            <div *ngIf="!isLoggedIn" class="auth-warning">
                <span class="auth-warning__title">⚠️ Authentication Required</span>
                <span>You must be logged in to upload a CSV and build your cart. Please sign in or register to continue.</span>
                <div class="auth-warning__actions">
                    <a [routerLink]="['/account/sign-in']" (click)="onCancel()" class="auth-warning__btn auth-warning__btn--primary">Sign In</a>
                    <a [routerLink]="['/account/register']" (click)="onCancel()" class="auth-warning__btn auth-warning__btn--secondary">Register</a>
                </div>
            </div>
            <p *ngIf="isLoggedIn" class="text-gray-700 text-xs sm:text-sm leading-relaxed">
                <ng-container *ngIf="!isConsolidatedFeedImport">
                    You can download an example template below to check the
                    formatting.
                </ng-container>
                <ng-container *ngIf="isConsolidatedFeedImport">
                    Download the consolidated feed template. Offer ID can be left blank.
                </ng-container>
                <button (click)="downloadTemplate()" class="download-link" type="button">
                    Download template
                </button>
            </p>
        </div>

        <div class="mb-4" *ngIf="isLoggedIn">
            <div class="upload-area" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)" [class.drag-over]="isDragOver">
                <div class="flex flex-col items-center">
                    <button (click)="triggerFileInput()" class="upload-btn" type="button" aria-label="Upload file">
                        <fa-icon [icon]="['fas', 'plus']" class="w-5 h-5 sm:w-6 sm:h-6 text-white"></fa-icon>
                    </button>
                    <p class="text-gray-700 mb-2 text-sm sm:text-base">
                        <button (click)="triggerFileInput()" class="upload-link-btn" type="button">
                            Upload a file
                        </button>
                        <span class="text-gray-500 block sm:inline mt-1 sm:mt-0">
                            <span class="hidden sm:inline"> or </span>drag and
                            drop a file to upload
                        </span>
                    </p>
                    <p class="text-gray-500 text-xs sm:text-sm">
                        Supported formats: .xls, .xlsx, .csv
                    </p>
                </div>
            </div>
            <input #fileInput type="file"
                accept=".csv,.xls,.xlsx,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                style="display: none" (change)="onFileSelected($event)" />
        </div>

        <div class="status-container" [ngClass]="getStatusClass()" *ngIf="isLoggedIn">
            <fa-icon [icon]="getStatusIcon()" [class.fa-spin]="isUploading" class="status-icon"></fa-icon>
            <div class="upload-modal__status-text" role="status">{{ getStatusMessage() }}</div>
        </div>

        </div>
        <div class="upload-modal__footer" *ngIf="isLoggedIn">
            <button (click)="onUpload()" [disabled]="!selectedFile || isUploading" [class]="getUploadButtonClass()"
                type="button">
                <span *ngIf="isUploading" class="flex items-center justify-center">
                    <fa-icon [icon]="['fas', 'spinner']" class="mr-2 w-4 h-4 fa-spin"></fa-icon>Uploading...
                </span>
                <span *ngIf="!isUploading && uploadStatus === 'success'" class="flex items-center justify-center">
                    <fa-icon [icon]="['fas', 'check']" class="mr-2 w-4 h-4"></fa-icon>Uploaded!
                </span>
                <span *ngIf="!isUploading && uploadStatus !== 'success'">Upload cart</span>
            </button>
        </div>
    </div>
</vsf-modal>